import { ComponentRef, ViewContainerRef } from '@angular/core';
import { PassKeyAuthenticateFormComponent } from './pass-key-authenticate-form.component';

class PassKeyAuthenticateFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  viewContainerRef: ViewContainerRef;
  passKeyAuthenticateFormComponent: ComponentRef<PassKeyAuthenticateFormComponent>;
  username: any;

  constructor(formId: string, payload: object) {

  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

    this.username =  clientContext['userID'];

    this.setupForm.call(this);
    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;

  }
  endSession(): void {

    this.setAsScreen.call(this);
  }

  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {

    this.viewContainerRef.clear();

    this.passKeyAuthenticateFormComponent = this.viewContainerRef.createComponent(PassKeyAuthenticateFormComponent);

    // const journeyPayload = this.payload as JourneyPayload;
    // const action = journeyPayload.actions[0] as ActionsInPayload;

    return new Promise((resolve, reject) => {
      this.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
          this.submitBlock = null;
        } catch (e) {

        }
      };
    });
  }

  onContinue(payload: object): void {

  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  handleNext(e){
   this.submitBlock({
        action: 'submit',
        webauthntoken: null,
        error: e
    });
  }

//  passkeyAuthenticate(){
//     const this = this;

//     (window as any).tsPlatform.webauthn.isPlatformAuthenticatorSupported().then((results) => {

//         if (results){
//          (window as any).tsPlatform.webauthn.authenticate.modal(this.username).then((data3) => {
//          this.submitBlock({
//             action: 'submit',
//             webauthntoken: data3
//         });

//         }).catch((error1) => {

//           this.handleNext.call(this);
//          });
//         }
//         else{

//           this.handleNext.call(this);
//         }
//     }).catch((error) => {

//         // if business wants cross device, call crossDeviceLoginFlow
//         this.handleNext.call(this);
//     });
//   }

   async passkeyAuthenticate(){

    try {
       try {
       const res = await (window as any).tsPlatform.webauthn.authenticate.modal();
       if (res){

          this.submitBlock({
            action: 'submit',
            webauthntoken: res
          });
        }
        else{
          this.submitBlock({
            action: 'submit',
            webauthntoken: null,
            error: 'authenticate modal failure',
            failedreason: 'failed'
          });
        }
       }
       catch (e){
           this.submitBlock({
            action: 'submit',
            webauthntoken: null,
            error: e,
            failedreason: 'user cancelled'
          });
       }
    }
    catch (e){
        this.submitBlock({
          action: 'submit',
          webauthntoken: null,
          error: e,
          failedreason: 'failed'
        });
    }

  }

  async setupForm(){
     await this.passkeyAuthenticate.call(this);
     // $.get('password.html', () => {
        //  $(this.clientContext.uiContainer).html(data);

        //  $('#passwordSubmit').on('click', () => {
        //   this.handleNext.call(this);
        //   });

        //  $('#passkeyAuthenticate').on('click',() =>  {
        //   this.passkeyAuthenticate.call(this);
        //   });

        //  $('#custom-password-authenticator_cancel-button').on("click", () => {
        // const escapeOptions = this.actionContext.getEscapeOptions();
        // const qrlogin = escapeOptions.filter(option => option.getId() === 'qrlogin')[0];
        // const cancelOption = escapeOptions.filter(option => option.getId() === 'escape_1')[0];

       // com.ts.mobile.sdk.FormInput.createFormCancellationRequest();

        // });

        //  const showInModal = this.payload.showInModal;
        //  if (showInModal && showInModal === true) {
        //   this.setAsModal.call(this);
        //   }
      // });
  }

  setAsModal() {
      // const container = this.clientContext.uiContainer;
      // $(container).addClass('modal-style');
      // $('#input-password-screen').addClass('modal-content');
      // $('#input-password-screen-content').removeClass('bordered');
    }

  setAsScreen() {
      // const container = this.clientContext.uiContainer;
      // $(container).removeClass('modal-style');
      // $('#input-password-screen').removeClass('modal-content');
      // $('#input-password-screen-content').addClass('bordered');
  }

}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default PassKeyAuthenticateFormSession;
